import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema } from "../primitives/ids.js";
export const CareDashboardDecisionPurposeSchema = z.enum([
    "PRIORITIZE_FIX",
    "CONTACT_CLIENT",
    "APPROVE_WORK",
    "ADJUST_CONSENT",
]);
export const CareDashboardFieldV1Schema = z
    .object({
    fieldId: z.string(),
    label: z.string(),
    value: z.union([z.string(), z.number(), z.boolean()]),
    decisionPurpose: CareDashboardDecisionPurposeSchema,
})
    .strict();
export const CareDashboardV1Schema = z
    .object({
    schemaVersion: z.literal("care-dashboard.v1.0"),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    fields: z.array(CareDashboardFieldV1Schema).min(1),
    generatedAt: z.string().datetime(),
})
    .strict();
export function careDashboardFieldsSupportDecisions(fields) {
    return fields.length > 0 && fields.every((f) => f.decisionPurpose.length > 0);
}
//# sourceMappingURL=care-dashboard.js.map